import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Data } from '@angular/router';
import { GradeLevel } from '@app/infrastructure/models/grade-level';
import { IGradeUnitListItemDTO } from '@app/infrastructure/models/grade-unit/grade-unit';
import { IPagedResults } from '@app/infrastructure/models/response';

@Component({
  selector: 'app-shared-grade-unit-list-presentation',
  templateUrl: './grade-unit-list-presentation.component.html',
  styleUrls: ['./grade-unit-list-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedGradeUnitListPresentationComponent {
  @Input() public gradeUnitList: IPagedResults<IGradeUnitListItemDTO>;
  @Input() public routeData: Data;
  @Output() public gradeSelection = new EventEmitter<number>();
  startDate: string;
  dayNumber: number;
  filteredCards: IGradeUnitListItemDTO[] = [];
  gradeFilter: number[] = [];

  constructor() {}

  selectGrade(gradeNum: number) {
    this.gradeSelection.emit(gradeNum);
  }
}
